import React, { useEffect, useMemo } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './Redux/Store/store';
import SplashScreen from 'react-native-splash-screen';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import 'intl-pluralrules';
import i18nextInit from './translations';
import 'intl-pluralrules';
import { NavigationContainer } from '@react-navigation/native';
import { routes } from './navigation/StackNavigator/routes';
import ErrorBoundary from './Apps/errorBoundary/ErrorBoundary';
import { Linking, Platform, Text, InteractionManager } from 'react-native';
import { RootApp } from './RootApp.js';
import NotificationListener from './NotificationListener';
import { setRedirectInfo } from './Redux/Reducers/deeplinkReducer.js';
import { isWeb, parseEventDataFromUrl } from './utils/Helper.js';

import { CRASHLYTICSCOLLECTION } from './config/Constant';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';

let crashlytics;
if (Platform.OS !== 'web') {
  const moduleName = '@react-native-firebase/crashlytics';
  import(/* webpackIgnore: true */ moduleName)
    .then(module => {
      crashlytics = module.default;
    })
    .catch(() => {});
}

// Initialize i18n synchronously at module level for faster startup
i18nextInit();

const { store, persistor } = configureStore();

const App = () => {


  const handleCrashlytics = async () => {
    if(crashlytics().isCrashlyticsCollectionEnabled != CRASHLYTICSCOLLECTION) {
      await crashlytics().setCrashlyticsCollectionEnabled(CRASHLYTICSCOLLECTION)
          .then(() => {
            console.log("Crashlytics data collection is enabled");
          })
          .catch((error) => console.error("Error enabling Crashlytics data collection:", error));
    }

    crashlytics().didCrashOnPreviousExecution(function(didCrash){
        console.log(`Did crash on previous execution: ${didCrash ? "Yes" : "No"}`);
    }, function(error){
        console.error(`Error getting Crashlytics did crash on previous execution: ${error}`);
    });
  }



  useEffect(() => {

    if (process.env.NODE_ENV === 'production') {
      console.log = () => {};
      console.error = () => {};
      console.warn = () => {};
      console.debug = () => {};
      console.info = () => {};
    }

    if (crashlytics) {
      setTimeout(() => {
        handleCrashlytics();
      },0);
    }

    // Hide splash screen immediately - RootApp will show loader if needed
    setTimeout(() => {
      SplashScreen && SplashScreen.hide();
    }, 1500);


    if(isWeb()){
      const url = window.location.href;
      if (url) handleDeepLink(url);
    } else {
      Linking.getInitialURL().then((url) => {
        if (url) handleDeepLink(url);
      });

      const listener = Linking.addEventListener('url', ({ url }) => {
          handleDeepLink(url);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleDeepLink = (url) => {
    console.log('Deep link received:', url);

    const eventData = parseEventDataFromUrl(url);

    console.log(eventData);
    if (eventData) {
        store.dispatch(setRedirectInfo(eventData));
    }
  }

  // Memoize linking config to avoid recreation on every render
  const linking = useMemo(() => ({
    config: {
      path: (process.env.REACT_APP_BASENAME || ''),
      screens: routes.reduce((acc, route) => {
        acc[route.name] = route.name?.toLowerCase();
        return acc;
      }, {}),
    },
  }), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18next}>
          <ErrorBoundary>
            <NavigationContainer 
              linking={linking}
              fallback={<Text>Loading...</Text>} 
              documentTitle={{
                formatter: (options, route) => `${process.env.REACT_APP_TITLE}`,
              }} 
            >
              <NotificationListener />
              <SafeAreaProvider>
                <RootApp />
              </SafeAreaProvider>
            </NavigationContainer>
          </ErrorBoundary>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
